<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small">
					<el-form-item label="角色名称">
						<el-input v-model="queryParams.name" placeholder="角色名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd"  v-has="'btn_add'">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="name" label="角色名称" width="150px"></el-table-column>
					<el-table-column prop="description" label="角色描述"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column label="操作" :width="width" v-if="width>0">
						<template slot-scope="scope">
							<el-button size="mini" @click="handleEdit(scope.row)" type="primary" :class="{ hidden: !(institutionId==scope.row.institutionId||institutionId==1||institutionId==-2) }"  v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" @click="handleDelete(scope.row)" type="danger" :class="{ hidden: !(institutionId==scope.row.institutionId)||scope.row.id==32||scope.row.id==1 }"  v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50,100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange">
				</el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/编辑 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
			<el-form :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="角色名称" prop="name">
					<el-input v-model="addOrUpdateForm.name"></el-input>
				</el-form-item>
				<el-form-item label="角色描述" prop="description">
					<el-input v-model="addOrUpdateForm.description"></el-input>
				</el-form-item>
				<el-form-item label="角色权限配置">
					<el-tree :data="authorityData" default-expand-all node-key="id" ref="tree" highlight-current :props="defaultProps" v-loading="treeLoading">
						<span class="custom-tree-node" slot-scope="{ node, data }">
							<span>
								<el-checkbox v-model="data.selected" @change="() => treeChange(node, data)"></el-checkbox>
								<i class="el-icon-switch-button" v-if="data.type=='btn'"></i>
								{{ node.label }}
							</span>
						</span>
					</el-tree>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import SearchBase from '@/components/layout/base/base-search-front.vue'

	export default {
		extends: SearchBase,
		data() {
			return {
				url: 'role',
				name: '角色',
				institutionId: null,
				queryParams: {
					sortOrder: 'asc',
					sortProp: 'id',
					defaultSort: {
						sortOrder: 'asc',
						sortProp: 'id'
					}
				},
				rules: {
					name: [{
						required: true,
						message: '角色名称不能为空',
						trigger: 'change'
					}]
				},
				treeLoading: true,
				roleId: null,
				checkedNodes: [],
				dialogAuthorityVisible: false,
				authorityData: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				}
			};
		},
		mounted: function() {
			this.institutionId = sessionStorage.getItem('_institutionId');
			if(this.institutionId>=1){
				this.queryParams.hideInRole=1
			}
		},
		methods: {
			beforeEdit() {
				this.handleAuthority({})
			},
			handleAuthority() { //分配权限弹出
				let that = this;
				this.treeLoading = true;
				this.checkedNodes = [];
				//this.dialogAuthorityVisible = true;
				this.authorityData = [];
				this.roleId = this.addOrUpdateForm.id;
				this.$http({
					method: 'POST',
					url: 'menus/roleMenusTree',
					data: {
						roleId: this.addOrUpdateForm.id
					},
				}).then(function(res) {
					that.authorityData = res.data.data;
					that.treeLoading = false;
				})
			},
			treeChange(node, data) {
				if (data.selected) {
					var parent = node.parent
					while(parent) {
						parent.data.selected = true
						parent = parent.parent
					}
				}
				this.checkChildren(node.childNodes,data.selected)
				console.log(node)
			},
			checkChildren(children,selected){
				if(children){
					var that = this;
					children.forEach(item=>{
						item.data.selected=selected;
						that.checkChildren(item.childNodes,selected)
					})
				}
			},
			beforeUpdate() {
				this.getCheckedNodes(this.authorityData)
				this.addOrUpdateForm.menuIds = this.checkedNodes;

			},
			handleSetAuthority() { //分配权限
				let that = this;
				let item = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
				let alr = [];
				item.forEach(i => {
					alr.push(parseInt(i));
				});
				this.$http({
					method: 'POST',
					url: 'menus/saveRoleMenus',
					data: {
						roleId: this.roleId,
						menuIds: alr
					},
				}).then(function(res) {
					if (res.data.errorCode == '0000') {
						that.successMessage('操作成功', '权限分配成功');
						that.dialogAuthorityVisible = false;
					}
				})
			},
			getCheckedNodes(data) { //获取权限树选中节点
				data.forEach(i => {
					if (i.selected) {
						this.checkedNodes.push(i.id);
					}
					if (i.children != null) {
						this.getCheckedNodes(i.children);
					}
				});
			}
		}
	}
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/view/system/role.vue